import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';

const SPREADSHEET_NOTE_CELL_HEIGHT = '24.8px';

export const spreadsheetNoteYearListStyles = (zoomLevel: number): StylesConfig<OptionType, false> => ({
  noOptionsMessage: styles => ({
    ...styles,
    fontSize: `${14 * zoomLevel}px`,
    textAlign: 'right',
  }),
  option: styles => ({
    ...styles,
    fontSize: `${14 * zoomLevel}px`,
    textAlign: 'right',
  }),
  menu: styles => ({
    ...styles,
    right: 0,
    marginTop: `-${SPREADSHEET_NOTE_CELL_HEIGHT}`,
  }),
});

export const spreadsheetNoteReferenceListStyles = (zoomLevel: number): StylesConfig<OptionType, false> => ({
  noOptionsMessage: styles => ({
    ...styles,
    fontSize: `${14 * zoomLevel}px`,
    textAlign: 'left',
  }),
  option: styles => ({
    ...styles,
    fontSize: `${14 * zoomLevel}px`,
  }),
  menu: styles => ({
    ...styles,
    right: 0,
    marginTop: `-${SPREADSHEET_NOTE_CELL_HEIGHT}`,
  }),
});
